import actionTypes from 'SRC/modules/redux/actionTypes'

export const setFormError = result => ({
  type: actionTypes.SET_FORM_ERROR,
  payload: result
})
